/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Price_First_YearInputs */

const en_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/first year`)
};

const ar_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/السنة الأولى`)
};

const de_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/erstes Jahr`)
};

const es_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/primer año`)
};

const fr_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/première année`)
};

const it_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/primo anno`)
};

const ja_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/初年度`)
};

const ko_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/첫 해`)
};

const pt_br_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/primeiro ano`)
};

const ru_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/первый год`)
};

const th_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ปีแรก`)
};

const tr_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ilk yıl`)
};

const zh_cn_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/首年`)
};

const zh_tw_subscription_price_first_year = /** @type {(inputs: Subscription_Price_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/首年`)
};

/**
* | output |
* | --- |
* | "/first year" |
*
* @param {Subscription_Price_First_YearInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_price_first_year = /** @type {((inputs?: Subscription_Price_First_YearInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Price_First_YearInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_price_first_year(inputs)
	if (locale === "ar") return ar_subscription_price_first_year(inputs)
	if (locale === "de") return de_subscription_price_first_year(inputs)
	if (locale === "es") return es_subscription_price_first_year(inputs)
	if (locale === "fr") return fr_subscription_price_first_year(inputs)
	if (locale === "it") return it_subscription_price_first_year(inputs)
	if (locale === "ja") return ja_subscription_price_first_year(inputs)
	if (locale === "ko") return ko_subscription_price_first_year(inputs)
	if (locale === "pt_br") return pt_br_subscription_price_first_year(inputs)
	if (locale === "ru") return ru_subscription_price_first_year(inputs)
	if (locale === "th") return th_subscription_price_first_year(inputs)
	if (locale === "tr") return tr_subscription_price_first_year(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_price_first_year(inputs)
	return zh_tw_subscription_price_first_year(inputs)
});